import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {ObjectionStatusFilterPropTypes} from "./FilterComponentPropTypes";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {lastRespondedByStatuses} from "../../../constants/constants";
const LastRespondedByFilter = ({
    allKey = "all",
    showAll = true,
    hideTitle = false,
    ...props
}: ObjectionStatusFilterPropTypes) => {
    const {t} = useTranslation(["lastRespondedByStatuses"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && (
                <h5 style={{whiteSpace: "nowrap"}}>
                    {t("fields.title", {ns: "lastRespondedByStatuses"})}
                </h5>
            )}
            <SelectField
                allowClear
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="lastRespondedByStatusSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option
                        value={allKey}
                        data-testid="lastRespondedByStatusSelect_option"
                    >
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {arrayAlphabeticalSort([...lastRespondedByStatuses], "value").map(
                    lastRespondedByStatus => (
                        <SelectField.Option
                            key={lastRespondedByStatus.value}
                            value={lastRespondedByStatus.value}
                            data-testid="lastRespondedByStatusSelect_option"
                        >
                            {t(lastRespondedByStatus.translation_key, {
                                ns: "lastRespondedByStatuses"
                            })}
                        </SelectField.Option>
                    )
                )}
            </SelectField>
        </React.Fragment>
    ));
};

export default LastRespondedByFilter;
